import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TServicesConnection } from 'hpscm/components/widgets/omnicom/serviceConnection/models'

export interface IHPSCMState {
  serviceConnections: {
    [p: string]: TServicesConnection | null
  }
}

const initialState: IHPSCMState = {
  serviceConnections: {},
}

const hpscmSlice = createSlice({
  name: '@hpscm',
  initialState: initialState,
  reducers: {
    setServiceConnections(state, action: PayloadAction<IHPSCMState['serviceConnections']>) {
      if (!action.payload) {
        return
      }
      const appId = Object.keys(action.payload)[0]
      const serviceConnectionData = Object.values(action.payload)[0]

      state.serviceConnections = {
        ...state.serviceConnections,
        [appId]: { ...(state.serviceConnections[appId] || {}), ...serviceConnectionData },
      }
    },
  },
})

export const { setServiceConnections } = hpscmSlice.actions
export default hpscmSlice.reducer
